import { useTranslation } from 'react-i18next';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import theme from 'src/theme/theme';
import {
  ReportingConnectResultContainer,
  ReportingConnectResultHeader,
  ReportingConnectResultLogo,
  ReportingConnectResultText,
} from './ReportingConnectResult.styles';

interface Props {
  connectSuccessful: boolean;
}

export const ReportingConnectResult = ({ connectSuccessful }: Props) => {
  const { t } = useTranslation();
  const icon = connectSuccessful ? 'check-circle' : 'exclamation-octagon';
  const iconColour = connectSuccessful
    ? theme.newPalette.turquoise.T400
    : theme.newPalette.red.R300;

  return (
    <ReportingConnectResultContainer>
      <ReportingConnectResultLogo>
        <StyledIcon
          className={`uil uil-${icon}`}
          size="70px"
          padding="0 4px 0 0"
          color={iconColour}
        />
      </ReportingConnectResultLogo>
      {connectSuccessful ? (
        <>
          <ReportingConnectResultHeader>
            {t('reporting.ReportingConnect.successfulConnectionHeading')}
          </ReportingConnectResultHeader>
          <ReportingConnectResultText>
            {t('reporting.ReportingConnect.successfulConnectionDescription')}
          </ReportingConnectResultText>
        </>
      ) : (
        <>
          <ReportingConnectResultHeader>
            {t('reporting.ReportingConnect.unsuccessfulConnectionHeading')}
          </ReportingConnectResultHeader>
          <ReportingConnectResultText>
            {t('reporting.ReportingConnect.unsuccessfulConnectionDescription')}
          </ReportingConnectResultText>
        </>
      )}
    </ReportingConnectResultContainer>
  );
};
